import React from 'react';
import HeaderButton from './ui/HeaderButton';
import { useDispatch, useSelector } from 'react-redux';
import { setShowMiniCart } from '../../Actions/Cart.action';

const MiniCart = () => {
  const dispatch = useDispatch();
  const { quantity, grandTotal, orderTotal } = useSelector(
    (state) => state.cart
  );

  return (
    <HeaderButton
      icon="Cart"
      label={orderTotal + ` (${quantity})`}
      onClick={() => dispatch(setShowMiniCart(true))}
      className="header__button--mini-cart"
      quantityIcon={quantity}
    ></HeaderButton>
  );
};

export default MiniCart;
